var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.064 7.628C9.49 7.628 9 7.152 9 6.564C9 5.976 9.49 5.5 10.064 5.5C10.652 5.5 11.128 5.976 11.128 6.564C11.128 7.152 10.652 7.628 10.064 7.628Z",
    fill: "#005C90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.182 14.698C9.182 15.188 9.574 15.594 10.064 15.594C10.554 15.594 10.96 15.188 10.96 14.698V9.532C10.96 9.042 10.554 8.636 10.078 8.636C9.574 8.636 9.182 9.042 9.182 9.532V14.698Z",
    fill: "#005C90"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20.5C4.47715 20.5 0 16.0228 0 10.5C0 4.97715 4.47715 0.5 10 0.5C15.5228 0.5 20 4.97715 20 10.5C20 16.0228 15.5228 20.5 10 20.5ZM10 18.5C14.4183 18.5 18 14.9183 18 10.5C18 6.08172 14.4183 2.5 10 2.5C5.58172 2.5 2 6.08172 2 10.5C2 14.9183 5.58172 18.5 10 18.5Z",
    fill: "#005C90"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.22adf328d624e6a7f9c54159e2edc265.svg";
export { ForwardRef as ReactComponent };